import * as React from "react"
import { AfterPage } from "types/afterjs"
import { Accordion, Paper, Seo } from "components"
import answers from "./data"

import "./faqPage.scss"

import { UncontrolledCollapse, CardBody, Card, CardHeader } from "reactstrap"

interface FAQPage {
	//
}

const FAQPage: AfterPage<FAQPage> = () => {
	return (
		<>
			<Seo
				title="سوالات متداول"
				description="پاسخ به سوالات متداول و راهنمای خرید از وب سایت مرجع آنتی ویروس ایران"
				path="/faq"
			/>
			<Paper>
				<Accordion>
					{answers.map((answer) => (
						<React.Fragment key={answer.id}>
							<CardHeader
								id={`anwser-${answer.id}`}
								className="cursor-pointer"
							>
								{answer.heading}
							</CardHeader>
							<UncontrolledCollapse
								toggler={`anwser-${answer.id}`}
							>
								<Card>
									<CardBody>{answer.details}</CardBody>
								</Card>
							</UncontrolledCollapse>
						</React.Fragment>
					))}
				</Accordion>
			</Paper>
		</>
	)
}

export default FAQPage
